import $ from 'jquery';

function bindClose(modalEl) {
	if (!modalEl || modalEl.dataset.staffVoiceZoomCloseBound === 'true') return;

	const closeButton = modalEl.querySelector('.js-staff-voice-modal-close');
	if (closeButton instanceof HTMLButtonElement) {
		closeButton.addEventListener('click', () => {
			$.magnificPopup.close();
		});
	}

	modalEl.dataset.staffVoiceZoomCloseBound = 'true';
}

function resolveZoomFigureAndImg(trigger) {
	const figure =
		trigger.closest('.staffVoiceCard__figure') || trigger.closest('.voice__cardFigure');
	if (!figure) return null;

	const thumbImg =
		figure.querySelector('.staffVoiceCard__img') || figure.querySelector('.voice__cardImg');
	return thumbImg ? { figure, thumbImg } : null;
}

function openStaffVoiceZoom(trigger) {
	const modalEl = document.getElementById('staff-voice-image-modal');
	if (!(modalEl instanceof HTMLElement)) return;

	const ctx = resolveZoomFigureAndImg(trigger);
	if (!ctx) return;

	const { thumbImg } = ctx;
	let dataHost = trigger;
	if (trigger instanceof HTMLElement) {
		if (trigger.classList.contains('voice__cardFigure')) {
			dataHost = trigger.querySelector('.voice__cardZoom') || trigger;
		} else if (trigger.classList.contains('staffVoiceCard__figure')) {
			dataHost = trigger.querySelector('.staffVoiceCard__zoom') || trigger;
		}
	}
	const src =
		dataHost.getAttribute('data-zoom-src') || thumbImg.getAttribute('src') || '';
	if (!src) return;

	const alt = thumbImg.getAttribute('alt') || '';
	const caption = dataHost.getAttribute('data-zoom-caption') || '';

	const mainImg = modalEl.querySelector('.js-staff-voice-modal-main');
	const captionEl = modalEl.querySelector('.js-staff-voice-modal-caption');

	if (mainImg instanceof HTMLImageElement) {
		mainImg.src = src;
		mainImg.alt = alt;
	}

	if (captionEl) {
		const hasCaption = Boolean(caption.trim());
		captionEl.textContent = caption;
		captionEl.toggleAttribute('hidden', !hasCaption);
	}

	bindClose(modalEl);

	const openPopup = () => {
		$.magnificPopup.open({
			items: {
				src: '#staff-voice-image-modal',
				type: 'inline',
			},
			closeBtnInside: true,
			mainClass: 'bukken-detail-gallery-popup',
		});
	};

	if ($.fn.magnificPopup) {
		openPopup();
	} else {
		import('magnific-popup/dist/jquery.magnific-popup.js').then(openPopup);
	}
}

export function init() {
	document.addEventListener('click', (event) => {
		const zoomFigure =
			event.target.closest('.staffVoiceCard__figure') ||
			event.target.closest('.voice__cardFigure');
		if (!(zoomFigure instanceof HTMLElement)) return;
		event.preventDefault();
		openStaffVoiceZoom(zoomFigure);
	});
}
